import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ISortAttribute, ISourceSchema } from "@types";
import React from "react";
import { Select } from "uxp/components";
import './SortEditor.scss'

interface ISortEditorProps {
    conditions: ISortAttribute[],
    onChange: (conditions: ISortAttribute[]) => void,
    fields: ISourceSchema
}

export const SortEditor: React.FunctionComponent<ISortEditorProps> = (props) => {
    const { conditions, onChange, fields } = props;

    function addCondition() {
        const newCondition: ISortAttribute = { field: '', descending: false };
        onChange([...conditions, newCondition]);
    }

    function updateCondition(index: number, field: string, value: string | boolean) {
        const updatedConditions = conditions.map((condition, i) => {
            if (i === index) {
                return { ...condition, [field]: value };
            }
            return condition;
        });
        onChange(updatedConditions);
    }

    function removeCondition(index: number) {
        const updatedConditions = conditions.filter((_, i) => i !== index);
        onChange(updatedConditions);
    }

    return (
        <div className="query-editor-sort-editor-container">

            <div className="query-editor-sort-conditions-container">
                {conditions?.map((c, i) => {
                    return <div className="query-editor-sort-condition-row" key={i}>
                        <div className="query-editor-sort-condition-content">
                            <div className="query-editor-sort-condition-value">
                                <Select
                                    selected={c?.field || ''}
                                    onChange={v => updateCondition(i, 'field', v)}
                                    options={fields || []}
                                    valueField='name'
                                    labelField='name'
                                    className='query-editor-input'
                                    showEndOfContent={false}
                                />
                            </div>

                            <div className="query-editor-sort-condition-value">
                                <Select
                                    selected={c?.descending ? 'desc' : 'asc'}
                                    onChange={v => updateCondition(i, 'descending', v === 'desc')}
                                    options={[
                                        { label: 'Ascending', value: 'asc' },
                                        { label: 'Descending', value: 'desc' },
                                    ]}
                                    className='query-editor-input'
                                    showEndOfContent={false}
                                />
                            </div>
                        </div>

                        <div className='query-editor-sort-condition-remover' onClick={() => removeCondition(i)}>
                            <FontAwesomeIcon icon={['fas', 'times']} />
                        </div>
                    </div>
                })}
            </div>

            <div className='query-editor-sort-condition-add' onClick={addCondition}>+ Add condition</div>

        </div>
    );
}

export function validateSortConditions(conditions: ISortAttribute[]): { isValid: boolean, error?: string, uniqueAttributes?: string[] } {
    if (!conditions || conditions?.length === 0) {
        return { isValid: false, error: 'At least one condition is required' };
    }

    const uniqueAttributes = new Set<string>();

    for (const condition of conditions) {
        if (!condition.field) {
            return { isValid: false, error: 'All conditions need to be configured properly' };
        }
        uniqueAttributes.add(condition.field);
    }

    return { isValid: true, error: null, uniqueAttributes: Array.from(uniqueAttributes) }
}